import type { UUID } from "../../../../../utils/uuid";
import type { VideoNode } from "../video-node";
import type { VideoNodeMui } from "../video-node-mui";
import type { DOMConversionOutput } from "lexical";

export function isVideoElement(node: HTMLElement): boolean {
  return node.tagName === "DIV" && node.getAttribute("data-node-type") === "video-node";
}

export function convertVideoElement(
  domNode: Node,
  type: typeof VideoNode | typeof VideoNodeMui,
): DOMConversionOutput {
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  const element = domNode as Element;
  const videoUrl = element.getAttribute("node-video-url");
  const thumbnailUrl = element.getAttribute("node-thumbnail-url");
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  const assetId = element.getAttribute("node-video-asset-id") as UUID;
  const title = element.getAttribute("node-video-title");

  if (videoUrl && thumbnailUrl && domNode instanceof HTMLDivElement) {
    const widthPercentage = domNode.style.width ? parseFloat(domNode.style.width) / 100 : 1;
    const aspectRatio = domNode.style.aspectRatio ? parseFloat(domNode.style.aspectRatio) : 1;

    const node = new type(
      videoUrl,
      thumbnailUrl,
      aspectRatio,
      widthPercentage,
      title ?? undefined,
      assetId,
    );
    return { node };
  }
  return { node: null };
}
